import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Tippy from '@tippyjs/react';
import { ReactComponent as InformationIcon } from 'icons/Information.icon.svg';

import './FormFieldLabel.styles.scss';
import './FormFieldLabel.styles.responsive.scss';

type FormFieldLabelProps = {
  className?: string;
  isOptional?: boolean;
  text: string;
  optionalText?: string;
  hint?: React.ReactNode;
};

const FormFieldLabel: React.FC<FormFieldLabelProps> = (props) => {
  const { className, isOptional = false, optionalText, text, hint } = props;

  const classes = classNames('form-field-label', className);

  const { t } = useTranslation();

  return (
    <h5 className={classes}>
      {text}
      {isOptional && <span>{optionalText ?? t('optional')}</span>}
      {hint && (
        <Tippy
          className="tooltip-information video-tippy"
          content={hint}
          placement="bottom"
        >
          <InformationIcon />
        </Tippy>
      )}
    </h5>
  );
};

export default FormFieldLabel;
